import React, { Component } from "react";
import Slider from "react-slick";
import FadeIn from "react-lazyload-fadein";
import Image from '../global/Image';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';

export default class MediaItem extends Component {
	
	constructor(props) {
    	super(props);
    	this.state = {
			index 	: 0,
			open 	: false,
			opened 	: false,
		}
		this.handleToggle 	= this.handleToggle.bind(this);
		this.handleGoTo 	= this.handleGoTo.bind(this);
    }
    	
	componentDidMount() {
		setTimeout(() => {
			let slick = window.document.getElementsByClassName('scope-slick')[this.props.index];
			if (slick.getElementsByClassName('slick-prev').length > 0) {
				slick.getElementsByClassName('slick-prev')[0].addEventListener('mouseover', function(){
					document.documentElement.classList.add('state-prev-hover');
				});
				slick.getElementsByClassName('slick-prev')[0].addEventListener('mouseout', function(){
					document.documentElement.classList.remove('state-prev-hover');
				});
				slick.getElementsByClassName('slick-next')[0].addEventListener('mouseover', function(){
					document.documentElement.classList.add('state-next-hover');
				});
				slick.getElementsByClassName('slick-next')[0].addEventListener('mouseout', function(){
					document.documentElement.classList.remove('state-next-hover');
				});
			}
		}, 500);
	}
	
	handleToggle(_evt) {  
		_evt.preventDefault();  
	    if (this.state.open === true) {
	    	this.setState({ open : false });
	    } else {
		    this.setState({ open : true, opened : true });
	    }
    }
    
    handleGoTo(_evt) {
	    _evt.preventDefault();  
	    this.slider.slickGoTo(_evt.currentTarget.getAttribute('data-key'), false);
	    setTimeout(() => {
			this.setState({ open : true, gOpen : true });
		}, 10);
    }
      	
	render () {
		
		let item = this.props.item;
				
		const settings = {
			dots: 			false,
			arrows: 		true,
			infinite: 		true,
			speed: 			0,
			slidesToScroll: 1,
			centerMode: 	false,
			variableWidth: 	false,
			beforeChange: 	(current, next) => this.setState({ index:next })
		};
			
		let galleryClass = 'c-gallery';
		let open = false;
		if (item.permalink === window.location.pathname + '') {
			galleryClass = galleryClass + ' state-open';
			open = true;
		}
											
	    return (
	
			<div className="c-press__thumb">
			
				<Link to={{ pathname: item.permalink }} className="c-press__thumb__inner">
					
					<div className="c-press__thumb__image">
						
						<Image width={item.width} height={item.height} srcset={item.srcset} src={item.src} />

					</div>
					
					<h5 className="c-press__thumb__date" dangerouslySetInnerHTML={ {__html:item.date}}></h5>
					<h3 className="c-press__thumb__heading" dangerouslySetInnerHTML={ {__html:item.title}}></h3>
					
				</Link>
				
				{createPortal(
					<div className={galleryClass}>
						<div className="scope-slick">
							<div className="c-project__header">
																		
								<Link to={{ pathname: '/media' }} className="c-project__header__back" dangerouslySetInnerHTML={{__html:'<svg width="28" height="6" viewBox="0 0 28 6"><path d="M0 3L5 5.88675V0.113249L0 3ZM28 2.5L4.5 2.5V3.5L28 3.5V2.5Z" /></svg>Back to media'}}></Link>
					
								<h2 className="c-project__header__heading" dangerouslySetInnerHTML={{__html:item.title}}></h2>		
														
							</div>
							<Slider ref={slider => (this.slider = slider)} {...settings}>
								{item.gllry.map((slide,i) =>
									{
										if (open === true) {
											return (
												<div className="inner" key={i}>	
													<div className="c-gallery__slide">
														<FadeIn>
															{onload => (
																<img
																	alt={''} 
																	src={slide.src} 
																	srcSet={slide.srcset} 
																	onLoad={onload}
																/>
															)}
														</FadeIn>
													</div>
												</div>
											)
										} else {
											return (
												<div className="inner" key={i}>	
													<div className="c-gallery__slide">
													</div>
												</div>
											)
										}
									}
								)}
							</Slider>
						</div>
						<div className="c-gallery__text">
							{item.caption &&
								<h5 className="c-gallery__text__subheading" dangerouslySetInnerHTML={ {__html:item.caption}}></h5>
							}
						</div>
					</div>,
					document.body
				)}
				
			</div>
													
		)
	}
}
